// extracted by mini-css-extract-plugin
export var active = "StickyMenu-module--active--+RxWo";
export var isVisible = "StickyMenu-module--isVisible--RE00h";
export var mobileToggler = "StickyMenu-module--mobileToggler--Vb9KP";
export var notVisible = "StickyMenu-module--notVisible--u1JkI";
export var stickyMenu = "StickyMenu-module--stickyMenu--WLG+o";